import React from 'react';
import { TextButton } from 'scy/buttons';
import { linkText } from 'scy/utils.mod.scss';
import { modalFooter } from './styles.mod.scss';

export default function LoginFooter({ showLogin }) {
  return (
    <div className={modalFooter}>
      <small>
        Already have an account?{' '}
        <TextButton className={linkText} onClick={showLogin}>
          Log in
        </TextButton>
        .
      </small>
    </div>
  );
}
